import React from "react";
import ActionableCard from "./ActionableCard";
import Grid from "@mui/material/Grid2";
import SvgIcon from "@mui/material/SvgIcon";

export type ActionableCardListItem = {
  title: string;
  icon: any;
  link?: string;
  handleClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  /** Emits `navigation.dashboard_entry_clicked` with `entry_id` when the card is activated */
  telemetryDashboardEntry?: string;
  /** Emits `navigation.receivables_hub_action` with `hub_action` when the card is activated */
  telemetryReceivablesHubAction?: "suggested" | "search";
};

const ActionableCardList: React.FC<{ items: ActionableCardListItem[] }> = ({ items }) => {
  return (
    <Grid container={true} spacing={2}>
      {items.map((item, index) => (
        <Grid size={6} key={index}>
          <ActionableCard
            title={item.title}
            link={item.link}
            handleClick={item.handleClick}
            icon={<SvgIcon component={item.icon} sx={{ fontSize: "3rem" }} />}
            disabled={item.disabled || item.loading}
            telemetryDashboardEntry={item.telemetryDashboardEntry}
            telemetryReceivablesHubAction={item.telemetryReceivablesHubAction}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ActionableCardList;
